






























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app} from "@/shared/app.constants";

@Component({
  components: {
    DateComponent: () => import("@/components/common/Inputs/Date.vue"),
    DialogComponent: () => import("@/components/common/Dialog/DialogComponent.vue"),
    ImportTable: () => import("./TechnicalReport/Components/ProjectImpact/ImpactTable.vue")
  },
})
export default class ProjectImpact extends Vue {

  @Prop() readOnly: boolean;
  @Prop() grantId: number;
  @Prop() modelWrapper: any;

  selectedIndex: -1 
  showImpact: boolean = false;
  impactActions: any = [{ event: "close", text: "Close" }];

    /** Table Headers */
  get headers() {
      const actionHeaders = [{ value: "Action" }];
      return [ ..._app.reportScheduleHeaders, ...actionHeaders ];
  }

  editImpact(item: any) {   
      this.selectedIndex = this.modelWrapper.grant.techReportingPeriods.indexOf(item);
      this.showImpact = true;
  }
    
}
